module.exports = __webpack_public_path__ + "fonts/Rubik-400-hebrew16.7363e8f.woff2";